module.exports = __webpack_public_path__ + "img/icon-gp-128x128-09-button.27a9eefb.svg";